<template>
  <div>
    <modal @close="onCancel">
      <h3 slot="header">{{ title }}</h3>
      <div slot="body">
        <label-select
          v-on="listeners"
          :label="getLabel"
          :options="options"
          :value="value"
          :searchable="searchable"
          :disabled="disabled"
          :error="error"
          :errorMessage="errorMessage">
        </label-select>
        <slot
          name="extra">
        </slot>
      </div>
      <div slot="footer">
        <btn-pill btn-size="s" @click="onOk">{{ okButtonText() }}</btn-pill>
        <btn-pill btn-size="s" @click="onCancel"  btn-type="secondary">{{ cancelButtonText() }}</btn-pill>
      </div>
    </modal>
  </div>
</template>

<script>
import BtnPill from '@/components/shared/buttons/BtnPill';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Modal from '@/components/shared/dialogs/Modal';

export default {
  components: {
    BtnPill,
    LabelSelect,
    Modal
  },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    okButton: {
      type: String
    },
    cancelButton: {
      type: String
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    value: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listeners () {
      return {
        input: value => this.$emit('input', value)
      };
    },
    getLabel () {
      return this.label;
    }
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  methods: {
    onOk (event) {
      this.$emit('ok', event);
    },
    onCancel (event) {
      this.$emit('cancel', event);
    },
    okButtonText () {
      if (this.okButton === undefined) {
        return this.$t('commons.ok');
      }
      return this.okButton;
    },
    cancelButtonText () {
      if (this.cancelButton === undefined) {
        return this.$t('commons.cancel');
      }
      return this.cancelButton;
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 13:
          this.$emit('ok', event);
          break;
        case 27:
          this.$emit('cancel', event);
          break;
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/shared/dialogs/InputSelectModal.vue